//src/admin/pages/AdminAbandonedCarts.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { getAdminAbandonedCarts, sendAbandonedCartEmail } from "../../services/adminAbandonedCarts.api";
import { buildAbandonedCartWhatsAppMessage } from "../../utils/whatsappMessages";

function AdminAbandonedCarts() {
  const [isOpen, setIsOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const { lang } = useContext(AdminLanguageContext);

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
  const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
  const isAdmin = adminUser.role === "admin";

  const canAccess = isAdmin || perms.can_manage_orders;

  const [sendingId, setSendingId] = useState(null);
  const [toast, setToast] = useState(null);


  const handleSendEmail = async (row) => {
  if (!row?.email) return; // ✅ ignore

  try {
    setSendingId(row.userId);
    await sendAbandonedCartEmail(row.userId);
    setToast(lang === "AR" ? "✅ تم إرسال البريد" : "✅ Email sent");
  } catch (e) {
    setToast((lang === "AR" ? "❌ فشل الإرسال: " : "❌ Failed: ") + (e.message || ""));
  } finally {
    setSendingId(null);
    setTimeout(() => setToast(null), 3000);
  }
};


  useEffect(() => {
  if (!canAccess) {
    setLoading(false);
    return;
  }

  getAdminAbandonedCarts()
    .then(setRows)
    .finally(() => setLoading(false));
}, [canAccess]);

const handleSendWhatsApp = (row) => {
  if (!row?.phone) return;

  const phone = row.phone.replace(/\D/g, ""); // sanitize
  const msg = buildAbandonedCartWhatsAppMessage({
    name: row.name,
    cartLink: row.cartLink,
  });

  const url = `https://wa.me/${phone}?text=${msg}`;
  window.open(url, "_blank");
};


  return (
    <div className="flex bg-gray-100 min-h-screen">
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="flex-1 lg:ml-64">
        <AdminHeader setIsOpen={setIsOpen} />

       <main className="p-6">
  {!canAccess ? (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "غير مصرح لك بالوصول إلى هذه الصفحة"
          : "You are not allowed to access this page"}
      </p>
    </div>
  ) : (
  <>
    <h1 className="text-2xl font-bold text-cyan-700 mb-6">
      Abandoned Carts
    </h1>

         <div className="hidden md:block bg-white rounded-xl shadow overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3">Customer</th>
                  <th className="p-3">Phone</th>
                  <th className="p-3">Email</th>
                  <th className="p-3">Cart Items</th>
                  <th className="p-3">Last Update</th>
                  <th className="p-3">Link</th>
                  <th className="p-3">Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="p-4 text-center">
                      Loading...
                    </td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="p-4 text-center">
                      No abandoned carts 🎉
                    </td>
                  </tr>
                ) : (
                  rows.map((r, i) => (
                    <tr key={i} className="border-t">
                      <td className="p-3 font-semibold">{r.name}</td>
                      <td className="p-3">{r.phone}</td>
                      <td className="p-3">{r.email}</td>
                      <td className="p-3 text-sm">
                        {r.cartItems.map((it, idx) => (
                          <div key={idx}>
                            • {it.name_en} × {it.qty}
                          </div>
                        ))}
                      </td>
                      <td className="p-3 text-sm">
                        {new Date(r.cartUpdatedAt).toLocaleDateString()}
                      </td>
                      <td className="p-3">
                        <a
                          href={r.cartLink}
                          target="_blank"
                          rel="noreferrer"
                          className="text-cyan-600 underline"
                        >
                          Open Cart
                        </a>
                      </td>
                      <td className="p-3 space-y-2">
  {/* EMAIL */}
  <button
    onClick={() => handleSendEmail(r)}
    disabled={!r.email || sendingId === r.userId}
    className={`w-full px-3 py-1.5 rounded-lg text-sm font-semibold transition
      ${!r.email
        ? "bg-gray-200 text-gray-500 cursor-not-allowed"
        : "bg-cyan-600 text-white hover:bg-cyan-700"}
    `}
  >
    {sendingId === r.userId
      ? (lang === "AR" ? "جارٍ الإرسال..." : "Sending...")
      : (lang === "AR" ? "إرسال بريد" : "Send Email")}
  </button>

  {/* WHATSAPP */}
  <button
    onClick={() => handleSendWhatsApp(r)}
    disabled={!r.phone}
    className={`w-full px-3 py-1.5 rounded-lg text-sm font-semibold transition
      ${!r.phone
        ? "bg-gray-200 text-gray-500 cursor-not-allowed"
        : "bg-green-600 text-white hover:bg-green-700"}
    `}
  >
    {lang === "AR" ? "إرسال واتساب" : "Send WhatsApp"}
  </button>
</td>


                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* MOBILE VIEW */}
<div className="md:hidden space-y-4">
  {loading ? (
    <div className="bg-white p-4 rounded-xl shadow text-center">
      Loading...
    </div>
  ) : rows.length === 0 ? (
    <div className="bg-white p-4 rounded-xl shadow text-center">
      No abandoned carts 🎉
    </div>
  ) : (
    rows.map((r, i) => (
      <div
        key={i}
        className="bg-white rounded-xl shadow p-4 border"
      >
        {/* CUSTOMER */}
        <div className="font-bold text-cyan-700 text-lg">
          {r.name}
        </div>

        {/* CONTACT */}
        {r.phone && (
          <p className="text-sm text-gray-600 mt-1">
            📞 {r.phone}
          </p>
        )}

        {r.email && (
          <p className="text-sm text-gray-600">
            📧 {r.email}
          </p>
        )}

        {/* ITEMS */}
        <div className="mt-3">
          <p className="text-sm font-semibold text-gray-700 mb-1">
            Cart Items:
          </p>

          <ul className="text-sm text-gray-600 space-y-1">
            {r.cartItems.map((it, idx) => (
              <li key={idx}>
                • {it.name_en} × {it.qty}
              </li>
            ))}
          </ul>
        </div>

        {/* DATE */}
        <p className="text-xs text-gray-500 mt-3">
          Last update:{" "}
          {new Date(r.cartUpdatedAt).toLocaleDateString()}
        </p>

        {/* LINK */}
        <a
          href={r.cartLink}
          target="_blank"
          rel="noreferrer"
          className="inline-block mt-3 text-cyan-600 font-semibold underline text-sm"
        >
          Open Cart →
        </a>
        <button
  onClick={() => handleSendEmail(r)}
  disabled={!r.email || sendingId === r.userId}
  className={`mt-3 w-full px-3 py-2 rounded-xl text-sm font-semibold transition
    ${!r.email
      ? "bg-gray-200 text-gray-500 cursor-not-allowed"
      : "bg-cyan-600 text-white hover:bg-cyan-700"}
  `}
>
  {sendingId === r.userId
    ? (lang === "AR" ? "جارٍ الإرسال..." : "Sending...")
    : (lang === "AR" ? "إرسال بريد السلة" : "Send Cart Email")}
</button>
<button
  onClick={() => handleSendWhatsApp(r)}
  disabled={!r.phone}
  className={`mt-2 w-full px-3 py-2 rounded-xl text-sm font-semibold transition
    ${!r.phone
      ? "bg-gray-200 text-gray-500 cursor-not-allowed"
      : "bg-green-600 text-white hover:bg-green-700"}
  `}
>
  {lang === "AR" ? "إرسال واتساب" : "Send WhatsApp"}
</button>


      </div>
    ))
  )}
</div>

          </>
           )}
           {toast && (
  <div className="fixed bottom-6 right-6 z-[9999] animate-fadeSlide">
    <div className="bg-black text-white px-5 py-3 rounded-xl shadow-lg text-sm">
      {toast}
    </div>
  </div>
)}

        </main>
      </div>
    </div>
  );
}

export default AdminAbandonedCarts;
